import DefaultPage from "@/components/common/DefaultPage";
import fetchAPI from "@/components/utils/fetch-API";

export async function getStaticProps() {
  const about = fetchAPI("/api/pages/About/").then((data) => data.content);
  const history = fetchAPI("/api/pages/History/").then((data) => data.content);

  return {
    props: { about: await about, history: await history }, // will be passed to the page component as props
    revalidate: 3600,
  };
}

function AboutPage(props) {
  return (
    <DefaultPage
      headings={["ABOUT", "HISTORY"]}
      contents={[props.about, props.history]}
    />
  );
}

export default AboutPage;
